import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock, ShieldCheck } from 'lucide-react';
interface MiniPurchaseProps {
  checkoutUrl: string;
}
export function MiniPurchase({
  checkoutUrl
}: MiniPurchaseProps) {
  const includes = ['Manual completo de 1° a 6° año', 'Clases armadas + diapositivas', 'Actividades, TPs y evaluaciones', 'Acceso inmediato en PDF digital'];
  return <section className="bg-[#FAF7F2] py-10 md:py-14" data-id="element-147">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl shadow-xl border border-[#1F3A5F]/10 overflow-hidden" data-id="element-149">
          {/* Urgency strip */}
          <div className="bg-[#1F3A5F] text-white text-center py-2.5 px-4 flex items-center justify-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-wider" data-id="element-150">
            <Clock size={14} className="text-[#D4A574]" data-id="element-151" />
            Oferta por tiempo limitado — el precio sube pronto
          </div>

          <div className="p-6 md:p-8" data-id="element-152">
            <p className="text-center text-xs md:text-sm font-semibold uppercase tracking-wider text-gray-500 mb-2" data-id="element-153">
              Manual Académico — Lengua y Literatura
            </p>

            {/* Price block */}
            <div className="text-center mb-5" data-id="element-154">
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-155">
                <span className="text-gray-400 line-through text-lg md:text-xl" data-id="element-156">
                  $34.990
                </span>
                <span className="bg-[#2D6A4F]/10 text-[#2D6A4F] text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-157">
                  -43%
                </span>
              </div>
              <span className="block text-4xl md:text-5xl font-bold text-[#1F3A5F] font-oswald tracking-wide" data-id="element-158">
                $19.990
              </span>
              <span className="block text-xs md:text-sm text-gray-500 mt-1" data-id="element-159">
                ARS · pago único · acceso inmediato
              </span>
            </div>

            {/* Includes */}
            <ul className="space-y-2 mb-6 text-left max-w-sm mx-auto" data-id="element-160">
              {includes.map((item, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-161">
                  <CheckCircle2 className="text-[#2D6A4F] flex-shrink-0 mt-0.5" size={18} data-id="element-162" />
                  <span className="text-sm md:text-base text-gray-700" data-id="element-163">
                    {item}
                  </span>
                </li>)}
            </ul>

            {/* CTA */}
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-base md:text-lg font-bold py-4 px-6 rounded-xl text-center transition-all transform hover:scale-[1.02] shadow-lg" data-id="element-164">
              QUIERO ACCEDER AHORA 🔥
            </a>

            {/* Trust line */}
            <div className="flex items-center justify-center gap-2 mt-4 text-xs text-gray-500" data-id="element-165">
              <ShieldCheck size={14} className="text-[#2D6A4F]" data-id="element-166" />
              Compra segura · Descarga inmediata después del pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}